import { PermissionRuleEditorCommand } from '../controllers/PermissionRuleEditorCtrl';
import { IGranteePermissions } from '../models/IGranteePermissions';
import { Module } from '../Module';

export interface IPermissionsActionButton {
  name: string;
  translate: string;
  isDisabled(rule: IGranteePermissions): boolean;
  execute(rule: IGranteePermissions): void;
}

export class PermissionsPanelActionsFactory {
  public getPermissionsPanelActions(
      showPermissionRuleEditor: (rowIndex: number, action: PermissionRuleEditorCommand) => void,
      getRowIndex: (row: IGranteePermissions) => number): PermissionsPanelActions {
    return new PermissionsPanelActions(showPermissionRuleEditor, getRowIndex);
  }
}

export class PermissionsPanelActions {

  constructor(private showPermissionRuleEditor: (rowIndex: number, action: PermissionRuleEditorCommand) => void,
              private getRowIndex: (row: IGranteePermissions) => number) {}

  public getActionButtons(): IPermissionsActionButton[] {
    return [
      this.editPermissionRuleAction,
      this.deletePermissionRuleAction
    ];
  }

  private editPermissionRuleAction: IPermissionsActionButton = {
    name: 'edit',
    translate: 'edit',
    isDisabled: (rule: IGranteePermissions) => {
      return !rule;
    },
    execute: (rule: IGranteePermissions) => {
      this.showPermissionRuleEditor(this.getRowIndex(rule), 'edit');
    }
  };

  private deletePermissionRuleAction: IPermissionsActionButton = {
    name: 'delete',
    translate: 'deleteMessage',
    isDisabled: (rule: IGranteePermissions) => {
      return this.isAllUsersGroup(rule);
    },
    execute: (rule: IGranteePermissions) => {
      this.showPermissionRuleEditor(this.getRowIndex(rule), 'delete');
    }
  };

  private isAllUsersGroup(rule: IGranteePermissions): boolean {
    return rule && rule.group && rule.group.isAllUsersGroup;
  }
}

Module.instance().service('PermissionsPanelActionsFactory', PermissionsPanelActionsFactory);
